/**
 * @fileoverview gRPC-Web generated client stub for mlmbox.client.confirmation.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.15.8
// source: mlmbox/client/confirmation/v1/confirmation_guest.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var mlmbox_type_confirmation_pb = require('../../../../mlmbox/type/confirmation_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.mlmbox = {};
proto.mlmbox.client = {};
proto.mlmbox.client.confirmation = {};
proto.mlmbox.client.confirmation.v1 = require('./confirmation_guest_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.mlmbox.type.Confirmation>}
 */
const methodDescriptor_ConfirmationGuest_Get = new grpc.web.MethodDescriptor(
  '/mlmbox.client.confirmation.v1.ConfirmationGuest/Get',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  mlmbox_type_confirmation_pb.Confirmation,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  mlmbox_type_confirmation_pb.Confirmation.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mlmbox.type.Confirmation)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mlmbox.type.Confirmation>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mlmbox.client.confirmation.v1.ConfirmationGuest/Get',
      request,
      metadata || {},
      methodDescriptor_ConfirmationGuest_Get,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mlmbox.type.Confirmation>}
 *     Promise that resolves to the response
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestPromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mlmbox.client.confirmation.v1.ConfirmationGuest/Get',
      request,
      metadata || {},
      methodDescriptor_ConfirmationGuest_Get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest,
 *   !proto.mlmbox.type.Confirmation.Field.Notification>}
 */
const methodDescriptor_ConfirmationGuest_GenerateOneTimePassword = new grpc.web.MethodDescriptor(
  '/mlmbox.client.confirmation.v1.ConfirmationGuest/GenerateOneTimePassword',
  grpc.web.MethodType.UNARY,
  proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest,
  mlmbox_type_confirmation_pb.Confirmation.Field.Notification,
  /**
   * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  mlmbox_type_confirmation_pb.Confirmation.Field.Notification.deserializeBinary
);


/**
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mlmbox.type.Confirmation.Field.Notification)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mlmbox.type.Confirmation.Field.Notification>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestClient.prototype.generateOneTimePassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mlmbox.client.confirmation.v1.ConfirmationGuest/GenerateOneTimePassword',
      request,
      metadata || {},
      methodDescriptor_ConfirmationGuest_GenerateOneTimePassword,
      callback);
};


/**
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mlmbox.type.Confirmation.Field.Notification>}
 *     Promise that resolves to the response
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestPromiseClient.prototype.generateOneTimePassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mlmbox.client.confirmation.v1.ConfirmationGuest/GenerateOneTimePassword',
      request,
      metadata || {},
      methodDescriptor_ConfirmationGuest_GenerateOneTimePassword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest,
 *   !proto.mlmbox.type.ConfirmationConfirmResponse>}
 */
const methodDescriptor_ConfirmationGuest_Confirm = new grpc.web.MethodDescriptor(
  '/mlmbox.client.confirmation.v1.ConfirmationGuest/Confirm',
  grpc.web.MethodType.UNARY,
  proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest,
  mlmbox_type_confirmation_pb.ConfirmationConfirmResponse,
  /**
   * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  mlmbox_type_confirmation_pb.ConfirmationConfirmResponse.deserializeBinary
);


/**
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mlmbox.type.ConfirmationConfirmResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mlmbox.type.ConfirmationConfirmResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestClient.prototype.confirm =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mlmbox.client.confirmation.v1.ConfirmationGuest/Confirm',
      request,
      metadata || {},
      methodDescriptor_ConfirmationGuest_Confirm,
      callback);
};


/**
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mlmbox.type.ConfirmationConfirmResponse>}
 *     Promise that resolves to the response
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestPromiseClient.prototype.confirm =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mlmbox.client.confirmation.v1.ConfirmationGuest/Confirm',
      request,
      metadata || {},
      methodDescriptor_ConfirmationGuest_Confirm);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ConfirmationGuest_Cancel = new grpc.web.MethodDescriptor(
  '/mlmbox.client.confirmation.v1.ConfirmationGuest/Cancel',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestClient.prototype.cancel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mlmbox.client.confirmation.v1.ConfirmationGuest/Cancel',
      request,
      metadata || {},
      methodDescriptor_ConfirmationGuest_Cancel,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestPromiseClient.prototype.cancel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mlmbox.client.confirmation.v1.ConfirmationGuest/Cancel',
      request,
      metadata || {},
      methodDescriptor_ConfirmationGuest_Cancel);
};


module.exports = proto.mlmbox.client.confirmation.v1;

